var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangupDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.283 16.5993L14.508 14.8327L16.283 13.066L15.0997 11.8827L13.333 13.6577L11.5663 11.8827L10.383 13.066L12.158 14.8327L10.383 16.5993L11.5663 17.7827L13.333 16.0077L15.0997 17.7827M2.49967 0.666016C2.05765 0.666016 1.63372 0.84161 1.32116 1.15417C1.0086 1.46673 0.833008 1.89065 0.833008 2.33268V15.666C0.833008 16.591 1.57467 17.3327 2.49967 17.3327H9.00801C8.70801 16.816 8.49967 16.2493 8.39967 15.666H2.49967V2.33268H8.33301V6.49935H12.4997V9.89935C12.7747 9.85768 13.058 9.83268 13.333 9.83268C13.6163 9.83268 13.8913 9.85768 14.1663 9.89935V5.66602L9.16634 0.666016M4.16634 8.99935V10.666H10.833V8.99935M4.16634 12.3327V13.9993H8.33301V12.3327H4.16634Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangupDocument);
export default __webpack_public_path__ + "static/media/hangup-document.9f97035e02884569be1caa10cdc5f495.svg";
export { ForwardRef as ReactComponent };